module.exports = __webpack_public_path__ + "img/maison25.dab83a71.jpg";